module.exports = __webpack_public_path__ + "resources/img/img_document_recognizer_general1_m.5b3be4c5b0477ca5244b3a4a8c5f4174.png";